import { jsx as _jsx } from "react/jsx-runtime";
import { Pressable, StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
export const Backdrop = ({ color, onPress }) => {
    return (_jsx(Pressable, { style: [
            $.backdrop,
            color && { backgroundColor: theme.color.background[color] },
        ], onPress: onPress, accessible: false }));
};
const $ = StyleSheet.create({
    backdrop: Object.assign(Object.assign({}, StyleSheet.absoluteFillObject), { 
        // @ts-expect-error This is web only
        position: 'fixed', backgroundColor: '#000', opacity: 0.6 }),
});
